import { observer, Provider } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import initBrowserStores from '../../browser/initBrowserStores';
import BrowserStore from '../../browser/stores/BrowserStore';
import FlagStore from '../../stores/FlagStore';
import TopBarAlternative from '../TopBarAlternative/TopBarAlternative';

const trueStore = new FlagStore(true, () => null);
const falseStore = new FlagStore(false, () => null);

class ExitMessagePreview extends Component {
    static propTypes = {
        exitMessage: PropTypes.object, // eslint-disable-line react/forbid-prop-types,
    };

    browserStores = initBrowserStores({
        browser: {
            topBarUnpinned: falseStore,
            topBarNeedsMinimization: falseStore,
            canExitIsolation: () => true,
            blockAdsByDefault: true,
            showNotification: () => null,
            closeNotification: () => null,
            isTopBarMinificationAllowed: () => false,
            topBarMenu: falseStore,
            adBlock: trueStore,
            adBlockModal: falseStore,
            isConsolePreview: true,
            pageStatus: BrowserStore.PAGE_STATUS.SECURE_SITE,
            isHomePage: false,
            urlInputValue: 'https://urlisolation.com',
            notification: BrowserStore.NOTIFICATION.NEW_CONFIRM_EXIT_ISOLATION,
            navigateToUrl: () => null,
        },
        env: {
            isBrowserDefense: false,
            isUrlIsolation: true,
            screenWidthOffset: 394,
        },
    }, false);

    propagateOptionsToMockStores = () => {
        this.browserStores.browser.setExitIsoText(this.props.exitMessage.option === 'DEFAULT'
            ? null : this.props.exitMessage.text);
    };

    componentDidMount() {
        this.propagateOptionsToMockStores();
    }

    componentDidUpdate() {
        this.propagateOptionsToMockStores();
    }

    render() {
        return <div style={{ padding: 20, border: '1px solid #00000024', borderTop: '0 none' }}>
            <div style={{ background: '#00000061', minHeight: 250 }}>
                <Provider {...this.browserStores}>
                    <TopBarAlternative />
                </Provider>
            </div>
        </div>;
    }
}

export default observer(ExitMessagePreview);
